import React, { useState, type PropsWithChildren } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import NFIcon from '@components/shared/NFIcon'

interface Props {
  learnStyling?: boolean
}

const FeatureExpander: React.FC<PropsWithChildren<Props>> = ({ learnStyling, children }) => {
  const { t } = useTranslation()
  const [showFeatures, setShowFeatures] = useState(false)

  return (
    <div className="mt-6 flex flex-col">
      {/* Feature list - Desktop */}
      <div className="hidden lg:flex flex-col">{children}</div>

      {/* Feature list - Mobile */}
      {showFeatures && <div className="lg:hidden flex flex-col">{children}</div>}

      {/* Show / hide button */}
      <button
        type="button"
        onClick={() => setShowFeatures(!showFeatures)}
        className={classNames(
          'flex lg:hidden flex-row items-center justify-center w-full',
          { 'mt-8': showFeatures },
          learnStyling ? 'text-green' : 'text-orange'
        )}>
        <NFIcon icon={showFeatures ? 'minus-sign' : 'add-sign'} className="text-[18px]" />
        <span className="ml-1.5 text-lg">
          {t(showFeatures ? 'action.hideFeatures' : 'action.showFeatures')}
        </span>
      </button>
    </div>
  )
}

export default FeatureExpander
